export const ADD_IFSC_MASTER_UPLOAD = 'ADD_IFSC_MASTER_UPLOAD'
export const ADD_IFSC_MASTER_UPLOAD_FAILURE = 'ADD_IFSC_MASTER_UPLOAD_FAILURE'
export const ADD_IFSC_MASTER_UPLOAD_SUCCESS = 'ADD_IFSC_MASTER_UPLOAD_SUCCESS'

export const addIfscMasterUpload = (data) => {
    return {
        type: ADD_IFSC_MASTER_UPLOAD,
        data
    }
}

export const addIfscMasterUploadFailure  = (data) => {
    return {
        type: ADD_IFSC_MASTER_UPLOAD_FAILURE,
        data
    }
}
export const addIfscMasterUploadSuccess = (data) => {
    return {
        type: ADD_IFSC_MASTER_UPLOAD_SUCCESS,
        data
    }
}

export const IFSC_MASTER_TEMPLATE_REQUEST = 'IFSC_MASTER_TEMPLATE_REQUEST';
export const IFSC_MASTER_TEMPLATE_SUCCESS = 'IFSC_MASTER_TEMPLATE_SUCCESS';
export const IFSC_MASTER_TEMPLATE_FAILURE = 'IFSC_MASTER_TEMPLATE_FAILURE';

export const ifscMasterTemplateRequest = () => {
    return {
        type: IFSC_MASTER_TEMPLATE_REQUEST,
    }
}

export const ifscMasterTemplateSuccess = (data) => {
    return {
        type: IFSC_MASTER_TEMPLATE_SUCCESS,
        data
    }
}

export const ifscMasterTemplateFailure = (data) => {
    return {
        type: IFSC_MASTER_TEMPLATE_FAILURE,
        data
    }
}


export const IFSC_MASTER_DATA_EXCEL_SUCCESS = 'IFSC_MASTER_DATA_EXCEL_SUCCESS';
export const IFSC_MASTER_DATA_EXCEL_FAILURE = 'IFSC_MASTER_DATA_EXCEL_FAILURE';
export const IFSC_MASTER_DATA_EXCEL_REQUEST = 'IFSC_MASTER_DATA_EXCEL_REQUEST';

export const ifscMasterDataExcelRequest = () => {
    return {
        type: IFSC_MASTER_DATA_EXCEL_REQUEST,
    }
}

export const ifscMasterDataExcelSuccess = (data) => {
    return {
        type: IFSC_MASTER_DATA_EXCEL_SUCCESS,
        data
    }
}

export const ifscMasterDataExcelFailure = (data) => {
    return {
        type: IFSC_MASTER_DATA_EXCEL_FAILURE,
        data
    }
}





export const IFSC_MASTER_LIST_REQUEST = 'IFSC_MASTER_LIST_REQUEST';
export const IFSC_MASTER_LIST_SUCCESS = 'IFSC_MASTER_LIST_SUCCESS';
export const IFSC_MASTER_LIST_FAILURE = 'IFSC_MASTER_LIST_FAILURE';


export const ifscMasterListRequest = (data) =>({
    type: IFSC_MASTER_LIST_REQUEST,
    data
});

export const ifscMasterListSuccess = (data) =>({
    type: IFSC_MASTER_LIST_SUCCESS,
    data
});

export const ifscMasterListFailure = (data) =>({
    type: IFSC_MASTER_LIST_FAILURE,
    data
});
